import React from "react";
import ColumnRules from "./ColumnRules";


const ImportOnboardingColumnRules = () => {
  const rules = [
    {
      name: "name",
      required: true,
      options: ["Nome."],
    },
    {
      name: "curriculum",
      required: true,
      options: ["Curriculo."],
    },
    {
      name: "field_step",
      required: true,
      options: ["Ano/Período de promoção."],
    },
    {
      name: "semester",
      required: true,
      options: ["Semestre."],
    },
    {
      name: "year",
      required: true,
      options: ["Ano."],
    },
    {
      name: "course",
      required: true,
      options: ["Curso."],
    },
    {
      name: "start_at",
      required: true,
      options: ["Início em."],
    },
    {
      name: "end_at",
      required: true,
      options: ["Término em."],
    },
    {
      name: "vacancies",
      required: true,
      options: ["Vagas."],
    },
    {
      name: "boleto_service",
      required: true,
      options: ["Boleto Service."],
    },
    {
      name: "validity_start_date",
      required: true,
      options: ["Início de vigência do contrato."],
    },
    {
      name: "validity_end_date",
      required: true,
      options: ["Término de vigência do contrato."],
    },
  ];

  return <ColumnRules rules={rules} />;
};

export default ImportOnboardingColumnRules;
